// Medal definitions and unlock logic.
// Each medal has an id, name (Spanish), tier (gold/silver/bronze), description, and check function.

export const MEDALS = [
  {
    id: "primer_paso",
    name: "Primer Paso",
    tier: "bronze",
    description: "Completa tu primera ronda",
    check: (profile) => profile.stats.rounds >= 1,
  },
  {
    id: "ronda_perfecta",
    name: "Ronda Perfecta",
    tier: "gold",
    description: "Acierta todas las preguntas en una ronda",
    check: (_, lastRound) =>
      lastRound && lastRound.questions && lastRound.correct === lastRound.questions && lastRound.wrong === 0,
  },
  {
    id: "casi_perfecto",
    name: "Casi Perfecto",
    tier: "silver",
    description: "Falla solo 1 en una ronda",
    check: (_, lastRound) =>
      lastRound && lastRound.questions && lastRound.correct === lastRound.questions - 1,
  },
  {
    id: "racha_5",
    name: "Racha de 5",
    tier: "bronze",
    description: "Acierta 5 seguidas en una ronda",
    check: (_, lastRound) => lastRound && lastRound.maxStreak >= 5,
  },
  {
    id: "racha_10",
    name: "Racha Imparable",
    tier: "gold",
    description: "Acierta 10 seguidas en una ronda",
    check: (_, lastRound) => lastRound && lastRound.maxStreak >= 10,
  },
  {
    id: "maestro_suma",
    name: "Maestro de Sumas",
    tier: "silver",
    description: "Completa 3 rondas de Suma",
    check: (profile) => (profile.stats.perOperation?.suma?.rounds || 0) >= 3,
  },
  {
    id: "maestro_resta",
    name: "Maestro de Restas",
    tier: "silver",
    description: "Completa 3 rondas de Resta",
    check: (profile) => (profile.stats.perOperation?.resta?.rounds || 0) >= 3,
  },
  {
    id: "maestro_multi",
    name: "Maestro de Multiplicaciones",
    tier: "silver",
    description: "Completa 3 rondas de Multiplicación",
    check: (profile) => (profile.stats.perOperation?.multiplicacion?.rounds || 0) >= 3,
  },
  {
    id: "maestro_div",
    name: "Maestro de Divisiones",
    tier: "silver",
    description: "Completa 3 rondas de División",
    check: (profile) => (profile.stats.perOperation?.division?.rounds || 0) >= 3,
  },
  {
    id: "maestro_porcentajes",
    name: "Maestro de Porcentajes",
    tier: "silver",
    description: "Completa 3 rondas de Porcentajes",
    check: (profile) => (profile.stats.perOperation?.porcentajes?.rounds || 0) >= 3,
  },
  {
    id: "maestro_fracciones",
    name: "Maestro de Fracciones",
    tier: "silver",
    description: "Completa 3 rondas de Fracciones",
    check: (profile) => (profile.stats.perOperation?.fracciones?.rounds || 0) >= 3,
  },
  {
    id: "puntos_100",
    name: "100 Puntos",
    tier: "bronze",
    description: "Acumula 100 puntos",
    check: (profile) => profile.points >= 100,
  },
  {
    id: "puntos_500",
    name: "500 Puntos",
    tier: "gold",
    description: "Acumula 500 puntos",
    check: (profile) => profile.points >= 500,
  },
  {
    id: "maestro_fracciones",
    name: "Maestro de Fracciones",
    tier: "silver",
    description: "Completa 3 rondas de Fracciones",
    check: (profile) => (profile.stats.perOperation?.fracciones?.rounds || 0) >= 3,
  },
  {
    id: "racha_7",
    name: "Racha de 7 Días",
    tier: "silver",
    description: "Mantén tu racha durante 7 días seguidos",
    check: (profile) => (profile.streak?.bestStreak || 0) >= 7,
  },
  {
    id: "racha_30",
    name: "Racha de 30 Días",
    tier: "gold",
    description: "Mantén tu racha durante 30 días seguidos",
    check: (profile) => (profile.streak?.bestStreak || 0) >= 30,
  },
  {
    id: "maestro_decimales",
    name: "Maestro de Decimales",
    tier: "silver",
    description: "Completa 3 rondas de Decimales",
    check: (profile) => (profile.stats.perOperation?.decimales?.rounds || 0) >= 3,
  },
  {
    id: "maestro_algebra",
    name: "Maestro de Álgebra",
    tier: "silver",
    description: "Completa 3 rondas de Álgebra",
    check: (profile) => (profile.stats.perOperation?.algebra?.rounds || 0) >= 3,
  },
  {
    id: "maestro_geometria",
    name: "Maestro de Geometría",
    tier: "silver",
    description: "Completa 3 rondas de Geometría",
    check: (profile) => (profile.stats.perOperation?.geometria?.rounds || 0) >= 3,
  },
];

export function getMedal(id) {
  return MEDALS.find((m) => m.id === id);
}

// Compute newly unlocked medals after a round or daily challenge
export function computeUnlockedMedals(profileAfter, lastRound, lastDaily) {
  const already = new Set(profileAfter.medals || []);
  const newly = [];
  for (const m of MEDALS) {
    if (already.has(m.id)) continue;
    if (m.check(profileAfter, lastRound, lastDaily)) newly.push(m.id);
  }
  return newly;
}
